import TypeToReducer from 'type-to-reducer';
import { combineReducers } from 'redux';
import { PENDING, FULFILLED, REJECTED } from 'redux-promise-middleware';
import { normalize, schema } from 'normalizr';

import {
  CLEAR_SUBCOMPANY,
  DELETE_SUBCOMPANY,
  GET_SUBCOMPANIES,
  GET_SUBCOMPANY,
  MODIFY_SUBCOMPANY,
  SAVE_SUBCOMPANY,
  TOGGLE_SUBCOMPANY,
  RESET_SUBCOMPANIES,
} from 'subcompanies/constants';

const subcompany = new schema.Entity('subcompanies');

export const initialStateList = {
  isFetching: true,
  result: {},
  entities: {},
};

export const getPending = (state, { payload }) => ({
  ...state,
  isFetching: true,
});
export const getFulfilled = (state, { payload }) => {
  return {
    ...state,
    isFetching: false,
    ...normalize({ subcompanies: payload.subcompanies }, { subcompanies: [subcompany] }),
  };
};
export const getRejected = (state, { payload }) => ({
  ...state,
  byId: initialStateList.byId,
  allIds: initialStateList.allIds,
  isFetching: false,
});

export const togglePending = (state, { meta }) => ({
  ...state,
  entities: {
    ...state.entities,
    subcompanies: {
      ...state.entities.subcompanies,
      [meta.subcompanyId]: { ...state.entities.subcompanies[meta.subcompanyId], isLoading: true },
    },
  },
});
export const toggleFulfilled = (state, { meta, payload }) => ({
  ...state,
  entities: {
    ...state.entities,
    subcompanies: {
      ...state.entities.subcompanies,
      [meta.subcompanyId]: { ...payload.subcompany, isLoading: false },
    },
  },
});
export const toggleRejected = (state, { meta, payload }) => ({
  ...state,
  entities: {
    ...state.entities,
    subcompanies: {
      ...state.entities.subcompanies,
      [meta.subcompanyId]: { ...state.entities.subcompanies[meta.subcompanyId], isLoading: false },
    },
  },
});

export const deletePending = (state, { meta }) => ({
  ...state,
  entities: {
    ...state.entities,
    subcompanies: {
      ...state.entities.subcompanies,
      [meta.subcompanyId]: { ...state.entities.subcompanies[meta.subcompanyId], isLoading: true },
    },
  },
});

export const deleteFulfilled = (state, { meta, payload }) => {
  const ids = state.result.subcompanies.filter((id) => id !== meta.subcompanyId);
  return {
    ...state,
    result: {
      ...state.result,
      subcompanies: [...ids],
    },
    entities: {
      ...state.entities,
      subcompanies: ids.reduce((re, id) => ({ ...re, [id]: state.entities.subcompanies[id] }), {}),
    },
  };
};

export const deleteRejected = (state, { meta, payload }) => ({
  ...state,
  entities: {
    ...state.entities,
    subcompanies: {
      ...state.entities.subcompanies,
      [meta.subcompanyId]: { ...state.entities.subcompanies[meta.subcompanyId], isLoading: false },
    },
  },
});

export const reset = (state) => ({ ...initialStateList });

const reducersList = {
  [GET_SUBCOMPANIES]: {
    [PENDING]: getPending,
    [FULFILLED]: getFulfilled,
    [REJECTED]: getRejected,
  },
  [TOGGLE_SUBCOMPANY]: {
    [PENDING]: togglePending,
    [FULFILLED]: toggleFulfilled,
    [REJECTED]: toggleRejected,
  },
  [DELETE_SUBCOMPANY]: {
    [PENDING]: deletePending,
    [FULFILLED]: deleteFulfilled,
    [REJECTED]: deleteRejected,
  },
  [RESET_SUBCOMPANIES]: reset,
};

export const initialStateForm = {
  subcompany: {
    name: '',
    shortname: '',
    active: true,
  },
  isFetching: false,
  isSaving: false,
};

export const resetForm = (state) => ({ ...initialStateForm });

export const modifySubcompany = (state, { payload }) => ({
  ...state,
  subcompany: { ...state.subcompany, ...payload },
});

export const saveSubcompanyPending = (state, { payload }) => ({
  ...state,
  isSaving: true,
});
export const saveSubcompanyFulfilled = (state, { payload }) => ({
  ...state,
  isSaving: false,
});
export const saveSubcompanyRejected = (state, { payload }) => ({
  ...state,
  isSaving: false,
});

export const getByIdPending = (state, { payload }) => ({
  ...state,
  isFetching: true,
});
export const getByIdFulfilled = (state, { payload: { subcompany } }) => ({
  ...state,
  subcompany,
  isFetching: false,
});
export const getByIdRejected = (state, { payload }) => ({
  ...state,
  isFetching: false,
});

const reducersForm = {
  [CLEAR_SUBCOMPANY]: resetForm,
  [GET_SUBCOMPANY]: {
    [PENDING]: getByIdPending,
    [FULFILLED]: getByIdFulfilled,
    [REJECTED]: getByIdRejected,
  },
  [MODIFY_SUBCOMPANY]: modifySubcompany,
  [SAVE_SUBCOMPANY]: {
    [PENDING]: saveSubcompanyPending,
    [FULFILLED]: saveSubcompanyFulfilled,
    [REJECTED]: saveSubcompanyRejected,
  },
};

export default combineReducers({
  list: TypeToReducer(reducersList, initialStateList),
  form: TypeToReducer(reducersForm, initialStateForm),
});



// WEBPACK FOOTER //
// src/modules/secured/modules/subcompanies/reducers/subcompanies_reducers.js